// import Vue from 'vue';
import {Model} from '@vuex-orm/core';
import moment from 'moment';

export default class DonationBooking extends Model {
    static entity = 'donation_booking';
    static primaryKey = 'id_donation_booking';

    static fields() {
        return {
            id_donation_booking: this.number(null),
            id_donation: this.number(null),
            school_year: this.string(''),
            amount: this.number(null),
            entry_at: this.attr(null),
        };
    }

    get entryDateString() {
        return moment(this.entry_at).format("D.MM.YYYY");
    }
}